import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: '/',
    routes: [
        {
            path: '/assistant-ai',
            meta: {
              title: 'AI助手',
            },
            name: 'assistantAi',
            component: r => require.ensure([], () => r(require('@/pages/chat-ai/main.vue')), 'ChatAi')
        },
        {
            path: '/evaluation',
            name: 'evaluation',
            meta: {
              title: '测评中心',
            },
            component: r => require.ensure([], () => r(require('@/pages/evaluation/index.vue')), 'evaluation')
        },
        {
            path: '/myReport',
            name: 'myReport',
            meta: {
              title: '我的报告',
            },
            component: r => require.ensure([], () => r(require('@/pages/evaluation/my-report.vue')), 'myReport')
        },
        {
            path: '/myEvaluation',
            name: 'myEvaluation',
            meta: {
              title: '测评报告',
            },
            component: r => require.ensure([], () => r(require('@/pages/evaluation/my-evaluation.vue')), 'myEvaluation')
        },
        {
            path: '/answer',
            name: 'answer',
            meta: {
              title: '',
            },
            component: r => require.ensure([], () => r(require('@/pages/evaluation/answer.vue')), 'answer')
        },
        {
            path: '/answerSuccess',
            name: 'answerSuccess',
            meta: {
              title: '',
            },
            component: r => require.ensure([], () => r(require('@/pages/evaluation/success.vue')), 'answerSuccess')
        },
        {
            path: '/resume',
            name: 'resume',
            meta: {
              title: '查看简历',
            },
            component: r => require.ensure([], () => r(require('@/pages/resume/index.vue')), 'resume')
        },
        {
            path: '/demo',
            name: 'demo',
            meta: {
              title: '生成附件简历',
            },
            component: r => require.ensure([], () => r(require('@/pages/resume/component/templateSimple.vue')), 'demo')
        },
        {
          path: '/resume/report/result',
          name: 'resumeReportResult',
          meta: {
            title: '简历诊断报告',
          },
          component: r => require.ensure([], () => r(require('@/pages/resume/report/result.vue')), 'resumeReportResult')
        },
        {
          path: '/job/report',
          name: 'jobReport',
          meta: {
            title: '职位适配分析报告',
          },
          component: r => require.ensure([], () => r(require('@/pages/job/report.vue')), 'resumeReportResult')
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js